/**
 * Created by mac on 7/23/18
 */

const Mission = function (type, data, fromServer) {
    cleverapps.EventEmitter.call(this);

    this.started = undefined;
    this.type = type;
    this.state = Mission.STATE_RUNNING;
    this.details = {};
    this.result = 0;
    this.needReview = false;

    this.onChangeResults = function () {};
    this.onCurrencyChanged = function () {};

    Object.assign(this, Missions[this.type]);

    if (this.isMinigameMission()) {
        this.currency = this.getStartCurrency();
    }

    if (this.type !== undefined && this.type === Mission.TYPE_LANTERN) {
        this.result = 1;
    }

    const isNewMission = !data;

    if (!isNewMission) {
        this.load(data);
    } else {
        if (this.schedule) {
            const { startDate } = MissionManager.parseWeekdayRange(this.schedule);
            this.started = startDate.getTime();
        } else if (this.feature && !this.duration) {
            const event = cleverapps.eventManager.getFeatureEvent(this.feature);
            this.started = event ? event.start.getTime() : Date.now();
        } else {
            this.started = Date.now();
        }
        // a launch-build mission started outside its weekday window - the save keeps the finish, so the regular build ends it on time too
        if (this.fixedFinish) {
            this.finish = this.started + cleverapps.parseInterval(this.duration);
        }
        this.needShowStartWindow = true;

        this.logEvent(Mission.EVENTS.MISSION_START);
    }

    if (this.oncePerEvent) {
        const event = cleverapps.eventManager.getFeatureEvent(this.feature);
        const lastEvent = !isNewMission && cleverapps.eventManager.getLastFeatureEvent(this.feature);
        if (lastEvent && (!event || this.started <= (lastEvent.start.getTime() + event.start.getTime()) / 2)) {
            this.eventFinishTime = lastEvent.finish.getTime();
        } else if (event) {
            this.eventFinishTime = event.finish.getTime();
        } else {
            this.eventFinishTime = Date.now();
        }
    }

    if (this.logic) {
        // eslint-disable-next-line new-cap
        this.logic = new this.logic(this, isNewMission);
    }

    this.updateCompetition(isNewMission || fromServer);

    this.onUpdateState();
};

Mission.prototype = Object.create(cleverapps.EventEmitter.prototype);
Mission.prototype.constructor = Mission;

Mission.STATE_RUNNING = 0;
Mission.STATE_COMPLETED = 1;

Mission.createRewardWindow = function (reward, missionData, options) {
    options = options || {};

    return new RewardWindow(reward, {
        shareId: options.shareId || missionData.rewardShareId,
        title: Messages.get(missionData.rewardTitle),
        text: Messages.get(missionData.rewardText),
        toMainWorld: missionData.mainWorldReward,
        toBubbleStack: cleverapps.config.type === "merge2",
        event: options.event || missionData.name,
        callback: options.callback
    });
};

Mission.prototype.displayCompleted = function (cb) {
    cleverapps.focusManager.compound(cb, [
        function (f) {
            this.wasDisplayedCompleted = true;

            let FinishWindow = this.finishWindow;
            if (this.logic && this.logic.getFinishWindow) {
                FinishWindow = this.logic.getFinishWindow();
            }

            if (FinishWindow) {
                new FinishWindow(this);
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        }.bind(this),

        function (f) {
            if (!this.lastChanceUsed && this.hasLastChance()) {
                this.lastChanceUsed = true;

                // eslint-disable-next-line new-cap
                new this.lastChanceView(this);
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        }.bind(this),

        function (f) {
            const isInTop = this.runningCompetition && this.place < 3;
            const reward = this.receiveReward();

            if (reward) {
                this.onChanged();

                this.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
                    reward,
                    itemId: `${this.place || 0}`
                });
                this.logDailyReward(this.place);
            }

            let received = false;

            const showNextReward = function (reward) {
                if (!reward) {
                    return;
                }

                Mission.createRewardWindow(reward, this, {
                    shareId: isInTop && "tournament",
                    callback: function () {
                        showNextReward(this.receiveReward());
                    }.bind(this)
                });

                received = true;
            }.bind(this);

            showNextReward(reward);

            if (received) {
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        }.bind(this),

        function (f) {
            if (this.canRemove() || this.manualFinish) {
                if (this.logic && this.logic.beforeRemove) {
                    this.logic.beforeRemove(f);
                } else {
                    f();
                }

                cleverapps.missionManager.remove(this);
            } else {
                f();
            }
        }.bind(this)
    ]);
};

Mission.prototype.onChanged = function () {
    this.trigger("changed");
};

Mission.prototype.onUpdateState = function () {
    if (this.logic && this.logic.onUpdateState) {
        this.logic.onUpdateState();
    }

    if (this.countdown) {
        this.countdown.remove();
        delete this.countdown;
    }

    if (this.isRunning()) {
        const leftTime = this.getTimeLeft();
        if (leftTime > 0) {
            this.countdown = new cleverapps.CountDown(leftTime, {
                onFinish: this.onUpdateState.bind(this),
                permanent: true
            });
        }
    } else {
        this.complete();
        this.stop();
    }

    this.updateMissionIcon();
};

Mission.prototype.isUnlocked = function () {
    if (this.logic && this.logic.isUnlocked) {
        return this.logic.isUnlocked();
    }
    return true;
};

Mission.prototype.setNeedReview = function (value) {
    this.needReview = value;
    this.updateMissionIcon();
};

Mission.prototype.updateMissionIcon = function () {
    cleverapps.missionManager.updateMissionIcon(this);
};

Mission.prototype.receiveIncome = function (amount, f) {
    const icon = cleverapps.sideBar.findMissionIcon(this.type);

    if (amount > 0 && icon) {
        icon.receiveIncome(amount, f);
    } else {
        f();
    }
};

Mission.prototype.userInfoChanged = function () {
    const playerInfo = cleverapps.user.getPlayerInfo();
    this.runningCompetition && this.runningCompetition.onEditProfile(playerInfo);

    this.resultsChanged();
};

Mission.prototype.resultsChanged = function () {
    this.onChangeResults();

    if (this.logic && this.logic.onChangeResults) {
        this.logic.onChangeResults();
    }
};

Mission.prototype.load = function (data) {
    this.started = data.started;
    this.finish = data.finish;
    this.result = data.result;
    this.details = data.details;
    this.currency = data.currency;
    this.rewardsReceived = data.claimed;
    this.needShowStartWindow = data.needStart || undefined;
};

Mission.prototype.update = function (result, details, silent) {
    if (!this.isRunning()) {
        result = undefined;
        details = undefined;
    }
    this.increaseResult(result, details, silent);
};

Mission.prototype.setResult = function (result, details, silent) {
    const delta = result - this.result;
    if (result !== this.result || details !== this.details) {
        this.result = result;
        if (details) {
            this.details = details;
        }

        cleverapps.user.incProgressCompare();
    }

    this._onResultChanged(delta, silent);
};

Mission.prototype.increaseResult = function (result, details, silent) {
    if (result || details) {
        this.result += result;
        if (details) {
            this.details = details;
        }
        cleverapps.user.incProgressCompare();

        if (this.logic && this.logic.logMissionAction) {
            this.logic.logMissionAction();
        } else if (result > 0 && !Mission.isTutorialRunning()) {
            this.logEvent(Mission.EVENTS.MISSION_ACTION, { once: true });
        }
    }

    this._onResultChanged(result, silent);
};

Mission.isTutorialRunning = function () {
    return cleverapps.tutorial.isActive()
        || typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive();
};

Mission.prototype._onResultChanged = function (delta, silent) {
    if (this.runningCompetition && delta) {
        this.runningCompetition.updatePlayerResult(Competition.PLAYER_ID, this.result);
    }

    if (this.logic && this.logic.logResultChange) {
        this.logic.logResultChange(delta);
    }

    this.onChanged();

    if (!silent) {
        this.onUpdateMission(delta);
    }
};

Mission.prototype.onUpdateMission = function (delta) {
    this.onUpdateState();

    if (delta) {
        this.onChangeResults();
    }

    if (this.logic && this.logic.onUpdateMission) {
        this.logic.onUpdateMission(delta);
    }
};

Mission.prototype.canRemoveSilently = function () {
    if (this.logic) {
        if (this.logic.canRemoveSilently) {
            return this.logic.canRemoveSilently();
        }
        return false;
    }

    if (this.result === 0) {
        return true;
    }

    const place = this.getSummary().place;
    return place === "?";
};

Mission.prototype.canRemove = function () {
    if (this.manualFinish) {
        return false;
    }

    if (this.logic && this.logic.canRemove) {
        return this.logic.canRemove();
    }

    return this.rewardsReceived;
};

Mission.prototype.hasLastChance = function () {
    if (!this.lastChanceView) {
        return false;
    }

    if (!this.canRemove() && !this.manualFinish) {
        return false;
    }

    if (this.logic && this.logic.hasLastChance) {
        return this.logic.hasLastChance();
    }

    return false;
};

Mission.prototype.receiveReward = function () {
    if (this.logic && this.logic.receiveReward) {
        return this.logic.receiveReward();
    }

    if (this.rewardsReceived) {
        return;
    }

    const prize = this.getPrize();

    if (prize && prize.unit && !this.mainWorldReward) {
        const left = cleverapps.toArray(prize.unit).length - Map2d.currentMap.countEmptySlots();
        if (left > 0) {
            cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left }));
            return;
        }
    }

    this.rewardsReceived = true;

    return prize;
};

Mission.prototype.skipNext = function () {
    return this.logic && this.logic.skipNext && this.logic.skipNext();
};

Mission.prototype.useMissionIntent = function (f) {
    const ViewClass = this.getViewClass();
    const view = ViewClass instanceof VirtualJson ? Prefab.instantiate(ViewClass, { args: [this] }) : new ViewClass(this);

    this.skipStartWindow();

    cleverapps.scenes.replaceScene(view, f);
};

Mission.prototype.updateCurrency = function (delta, details) {
    if (delta === 0) {
        return;
    }

    if (this.currency !== undefined) {
        this.currency += delta;
        if (details) {
            this.details = details;
        }

        this.onUpdateState();
        this.onCurrencyChanged();
        this.onChanged();

        if (delta < 0) {
            this.logEvent(Mission.EVENTS.MISSION_ACTION, { once: true });
        }
    }
};

Mission.prototype.getSummary = function () {
    if (this.runningCompetition) {
        return {
            place: this.runningCompetition.calcPlace(),
            points: this.runningCompetition.player.amount
        };
    }

    return {
        place: "?",
        points: this.result
    };
};

Mission.prototype.save = function () {
    if (this.logic && this.logic.save) {
        this.logic.save(this.details);
    }

    return {
        started: this.started,
        finish: this.finish,
        type: this.type,
        result: this.result,
        currency: this.currency,
        details: this.details,
        semaphore: this.semaphore,
        claimed: this.rewardsReceived,
        needStart: this.needShowStartWindow
    };
};

Mission.prototype.skipStartWindow = function () {
    if (this.needShowStartWindow) {
        this.needShowStartWindow = false;

        this.onChanged();
    }
};

Mission.prototype.getName = function () {
    return this.name;
};

Mission.prototype.getWindowBundleName = function () {
    return typeof this.bundle === "function" ? this.bundle() : this.bundle;
};

Mission.prototype.isMinigameMission = function () {
    return this.minigame !== undefined;
};

Mission.prototype.isPassMission = function () {
    return this.logic && typeof PassMissionLogic !== "undefined" && this.logic instanceof PassMissionLogic;
};

Mission.prototype.isSlotMachineMission = function () {
    return this.logic && typeof SlotMachineMissionLogic !== "undefined" && this.logic instanceof SlotMachineMissionLogic;
};

Mission.prototype.isTreasureSearchMission = function () {
    return this.logic && typeof TreasureSearchMissionLogic !== "undefined" && this.logic instanceof TreasureSearchMissionLogic;
};

Mission.prototype.isCompetitionMission = function () {
    return this.competition !== undefined;
};

Mission.prototype.isPinballMission = function () {
    return this.logic && typeof PinballMissionLogic !== "undefined" && this.logic instanceof PinballMissionLogic;
};

Mission.prototype.getViewClass = function () {
    if (this.logic && this.logic.getView) {
        return this.logic.getView();
    }

    return this.view;
};

Mission.prototype.complete = function () {
    if (this.state === Mission.STATE_RUNNING) {
        this.state = Mission.STATE_COMPLETED;

        cleverapps.missionManager.complete(this);
    }
};

Mission.prototype.getIcon = function () {
    return Mission.getCollectIcon(this.type);
};

Mission.prototype.finishTime = function (ignoreCompetition) {
    if (this.feature && !this.duration) {
        if (this.oncePerEvent) {
            return this.eventFinishTime;
        }
        const feature = cleverapps.eventManager.getFeatureEvent(this.feature)
            || cleverapps.eventManager.getLastFeatureEvent(this.feature);
        return feature ? feature.finish.getTime() : 0;
    }

    if (this.manualFinish) {
        return 0;
    }

    let finishTime;
    if (this.finish) {
        finishTime = this.finish;
    } else if (this.schedule) {
        const window = MissionManager.findWeekdayRange(this.schedule, this.started);
        finishTime = window ? window.endDate.getTime() : this.started;
    } else {
        finishTime = this.started + cleverapps.parseInterval(this.duration);
    }

    // a running round outlives the mission's own finish
    if (!ignoreCompetition) {
        const timeLeft = this.logic && this.logic.competitionTimeLeft && this.logic.competitionTimeLeft();
        if (timeLeft > 0) {
            finishTime = Math.max(finishTime, Date.now() + timeLeft);
        }
    }

    return finishTime;
};

Mission.prototype.getTimeLeft = function () {
    return Math.max(0, this.finishTime() - Date.now());
};

Mission.prototype.isRunning = function () {
    if (this.state === Mission.STATE_RUNNING) {
        if (this.manualFinish || this.getTimeLeft() > 0) {
            return true;
        }
    }
    return false;
};

Mission.prototype.isCompleted = function () {
    return this.state === Mission.STATE_COMPLETED;
};

Mission.prototype.canPlayMinigame = function () {
    return this.isMinigameMission() && this.currency && this.currency >= this.getMinigamePrice();
};

Mission.prototype.getMinigamePrice = function () {
    return this.minigame.price;
};

Mission.prototype.isMinigameReadyToFinish = function () {
    return this.isMinigameMission() && this.logic && this.logic.isMinigameReadyToFinish && this.logic.isMinigameReadyToFinish();
};

Mission.prototype.getStartCurrency = function () {
    return this.startCurrency !== undefined ? this.startCurrency : this.getMinigamePrice();
};

Mission.prototype.gamePlayed = function (game, level) {
    if (this.logic && this.logic.gamePlayed) {
        this.logic.gamePlayed(game, level);
    }
};

Mission.prototype.getPrize = function () {
    if (this.logic && this.logic.getPrize) {
        return this.logic.getPrize();
    }

    if (!this.prize) {
        return;
    }

    if (this.minigame) {
        if (!this.logic.isFinished()) {
            return undefined;
        }

        return this.prize;
    }

    this.place = this.getSummary().place;
    return this.getPrizeByPlace(this.place);
};

Mission.prototype.getPrizeByPlace = function (place) {
    let prize = this.prize;
    if (this.logic && this.logic.getStage) {
        prize = prize && prize[`stage${this.logic.getStage()}`];
    }

    prize = prize && prize[place];
    if (!prize) {
        return;
    }

    if (!["merge", "merge2"].includes(cleverapps.config.type) && this.prepareRewardByRich !== false) {
        return cleverapps.user.prepareRewardByRich(prize);
    }
    return prize;
};

Mission.prototype.updateCompetitionResults = function () {
    if (this.runningCompetition) {
        this.runningCompetition.updatePlayerResult(Competition.PLAYER_ID, this.result);
    }
};

Mission.prototype.updateCompetition = function (cleanData) {
    if (!this.isCompetitionMission()) {
        return;
    }

    this.stopCompetition();

    if (cleanData) {
        Competition.CLEAN_SAVED(this.type);
    }

    if (!this.isUnlocked()) {
        return;
    }

    let competition = this.competition;
    if (this.logic && this.logic.getCompetitionOptions) {
        competition = this.logic.getCompetitionOptions();
    }

    const options = {
        store: true,
        type: this.type,
        playerResult: this.result,
        amount: Array.isArray(competition.amount) ? PseudoRandom.GET("competition").random(competition.amount[0], competition.amount[1]) : competition.amount,
        oneWinner: competition.oneWinner,
        withScrollTable: competition.withScrollTable !== false,
        prizeIconsBundle: competition.prizeIconsBundle,
        getPrizeByPlace: this.getPrizeByPlace.bind(this),
        algo: {
            start: this.started,
            finish: this.finishTime(),
            ...competition
        }
    };

    this.runningCompetition = new Competition(options);

    this.runningCompetition.onChangeResultsListeners.mission = this.resultsChanged.bind(this);
    this.runningCompetition.onChangePlaceListener = this.updateMissionIcon.bind(this);

    this.playerInfoListener = cleverapps.user.on("userInfoChanged", this.userInfoChanged.bind(this), this);

    this.logic && this.logic.onUpdateCompetition && this.logic.onUpdateCompetition();

    if (this.runningCompetition.running) {
        this.runningCompetition.start();
    }
};

Mission.prototype.stopCompetition = function () {
    if (this.runningCompetition) {
        this.runningCompetition.stop();
    }
};

Mission.prototype.clearCompetition = function () {
    delete this.runningCompetition;
};

Mission.prototype.getCollectRewardEffect = function () {
    return this.logic && this.logic.getCollectRewardEffect && this.logic.getCollectRewardEffect();
};

Mission.prototype.isAvailable = function () {
    return (this.logic && this.logic.isAvailable) ? this.logic.isAvailable() : true;
};

Mission.prototype.getType = function () {
    return this.type;
};

Mission.prototype.stop = function () {
    this.stopCompetition();

    if (this.logic && this.logic.stop) {
        this.logic.stop();
    }
};

Mission.prototype.destructor = function () {
    if (this.countdown) {
        this.countdown.remove();
        delete this.countdown;
    }

    if (this.playerInfoListener) {
        this.playerInfoListener.clear();
        delete this.playerInfoListener;
    }

    this.stopCompetition();

    if (this.logic && this.logic.destructor) {
        this.logic.destructor();
    }

    this.purge();
};

Mission.GetMissionType = function (compoundType) {
    compoundType = String(compoundType).split("_");

    return cleverapps.castType(compoundType[0]);
};

Mission.CompoundType = function (missionType, locationId) {
    missionType = Mission.GetMissionType(missionType);

    const locationMission = Mission.MISSION_TYPE_BY_LOCATION_ID[locationId];

    return `${missionType}_${locationMission !== undefined ? locationMission : locationId}`;
};

Mission.getCollectIcon = function (type) {
    return cleverapps.skins.getSlot("missionIcon", {
        type
    });
};

// Missions
Mission.EVENTS = {
    MISSION_DAU: "mission_dau-",
    MISSION_UNLOCKED: "mission_unlock-",
    MISSION_POINTS: "mission_points-",
    MISSION_POINTS_DAU: "mission_points_dau-",
    MISSION_PROGRESS: "mission_progress-",
    MISSION_PROGRESS_DAU: "mission_progress_dau-",
    MISSION_STAGE: "mission_stage-",
    MISSION_FINISH: "mission_finish-",
    MISSION_WINDOW: "mission_window-",
    MISSION_WINDOW_DAU: "mission_window_dau-",
    MISSION_REWARD_VALUE: "mission_rwcost-",
    MISSION_REWARD: "mission_rw-",
    MISSION_PROLONGATION: "mission_prolongation-",
    MISSION_START: "mission_start-",
    // the mission left the player's list, rewarded or not; itemId says which
    MISSION_END: "mission_end-",
    // the activation the liveops charts count: points earned outside a tutorial, once per session
    MISSION_ACTION: "mission_action-",
    MISSION_ADS: "mission_ads-",
    MISSION_ATTENTION_ON: "mission_attention_on-",
    MISSION_ATTENTION_OFF: "mission_attention_off-",
    MISSION_WIN_TIME: "mission_wintime-",
    MISSION_LOSE_TIME: "mission_losetime-",
    MISSION_STAGE_TIME: "mission_stagetime-"
};

Mission.prototype.logEvent = function (event, options) {
    options = options || {};
    const index = options.index === undefined ? "" : `_${options.index}`;
    const params = {};
    if (options.value !== undefined) {
        params.value = options.value;
    }
    if (options.itemId !== undefined) {
        params.itemId = options.itemId;
    }
    if (options.reward !== undefined) {
        const rewards = options.reward instanceof RewardsList ? options.reward : new RewardsList(options.reward);
        params.value = RewardsList.calcCost(rewards);
        params.details = { reward: {} };
        rewards.listRewards().forEach((reward) => {
            const values = params.details.reward;
            values[reward.type] = values[reward.type] === undefined ? reward.value : cleverapps.toArray(values[reward.type]).concat([reward.value]);
        });
    }

    const finish = this.finishTime(true);
    if (finish) {
        params.event = Math.min(options.event !== undefined ? options.event : Date.now(), finish - 1);
    } else if (options.event !== undefined) {
        params.event = options.event;
    }

    const eventName = event + (this.eventName || this.getName().toLowerCase()) + index;

    if (options.once) {
        if (options.index !== undefined) {
            params.key = event + (this.eventName || this.getName().toLowerCase());
        }
        cleverapps.playSession.logEventOnce(eventName, params);
        return;
    }

    cleverapps.metrics.logEvent(eventName, params);
};

Mission.prototype.logDailyReward = function (index) {
    index = index || 0;
    const all = cleverapps.dataLoader.load(DataLoader.TYPES.MISSIONS_DAILY_REWARD) || {};
    const saved = all[this.type] || {};
    all[this.type] = { day: Date.now(), max: Math.max(saved.max || 0, index) };
    cleverapps.dataLoader.save(DataLoader.TYPES.MISSIONS_DAILY_REWARD, all);
};

if (typeof cc === "undefined") {
    module.exports = {
        Mission
    };
}
